var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content",class:{'bgWhite' : _vm.$route.meta.bgWhite === true}},[_c('div',{class:{'bgWhite' : _vm.$route.meta.bgWhite === true}},[_c('div',{staticClass:"container-fluid p-0"},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }